/* eslint-disable react/prop-types */
import { useState } from 'react';
import { FaMinus, FaPlus } from 'react-icons/fa6';

const SliderWithLabel = ({ label, min, max, step, onValueChange }) => {
  const [value, setValue] = useState(1100);

  const handleSliderChange = (e) => {
    const newValue = e.target.value;
    setValue(newValue);
    onValueChange(newValue);
  };

  const incrementValue = () => {
    if (value < max) {
      const newValue = Number(value) + step;
      setValue(newValue);
      onValueChange(newValue);
    }
  };

  const decrementValue = () => {
    if (value > min) {
      const newValue = Number(value) - step;
      setValue(newValue);
      onValueChange(newValue);
    }
  };

  return (
    <div className="flex items-center gap-4">
      {/* Label */}
      <label className="text-xl font-light text-[#EEEEEE] text-nowrap">{label}</label>
      
      {/* Slider */}
      <input
        type="range"
        min={min}
        max={max}
        value={value}
        step={step}
        onChange={handleSliderChange}
        className="w-32"
      />

      {/* Value Box */}
      <div className="flex items-center gap-1">
        <button onClick={decrementValue} className="flex items-center justify-center p-3 bg-gray-300 rounded"><FaMinus /></button>
        <input
          type="text"
          value={value}
          readOnly
          className="px-2 py-2 text-center border border-gray-400 rounded"
        />
        <button onClick={incrementValue} className="p-3 bg-gray-300 rounded"><FaPlus /></button>
      </div>
    </div>
  );
};

export default SliderWithLabel;
